// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
export type AssetIntegration_IntegrationEntityFragment = { __typename?: 'IntegrationEntity', kind: Types.IntegrationEntityKind, name: string, id: string };

export type AssetIntegration_EntityFragment = { __typename?: 'Entity', id: string, integrationEntities?: Array<(
    { __typename?: 'IntegrationEntity' }
    & AssetIntegration_IntegrationEntityFragment
  )> | null };

export const Operations = {
  Fragment: {
    AssetIntegration_IntegrationEntity: 'AssetIntegration_IntegrationEntity' as const,
    AssetIntegration_Entity: 'AssetIntegration_Entity' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const AssetIntegration_IntegrationEntityFragmentDoc = gql`
    fragment AssetIntegration_IntegrationEntity on IntegrationEntity {
  kind
  name
  id
}
    `;
export const AssetIntegration_EntityFragmentDoc = gql`
    fragment AssetIntegration_Entity on Entity {
  id
  integrationEntities {
    ...AssetIntegration_IntegrationEntity
  }
}
    ${AssetIntegration_IntegrationEntityFragmentDoc}`;